var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white p-3 rounded"},[_vm._m(0),_c('CustomTimeLine',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fa fa-info-circle mr-2 orange"}),_c('span',{staticClass:"title"},[_vm._v("Historial de Estatus")])])
}]

export { render, staticRenderFns }